<template>
  <div class="menu-list" :class="className">
    <van-tabs
      class="menu-list_tabs"
      :sticky="sticky"
      v-if="blinkFlag && configList.length > 1"
    >
      <van-tab
        v-for="item in configList"
        :key="item.key"
        :title="item.category_tag_name"
      >
        <Goods :config="item" :preview="preview" />
      </van-tab>
    </van-tabs>
    <Goods
      :config="configList[0]"
      :preview="preview"
      v-if="configList.length === 1"
    />
  </div>
</template>

<script>
import Goods from "../Goods";
const toGuids = list => list.map(it => it.key).join();

export default {
  name: "MenuList",
  props: {
    configList: Array,
    preview: Boolean,
    sticky: Boolean
  },
  components: { Goods },
  data() {
    return {
      activeTag: "",
      blinkFlag: true,
      list: []
    };
  },
  watch: {
    configList: {
      handler(now, old) {
        if (!this.preview || !now.length) return;
        if (now.length !== old.length || toGuids(now) !== toGuids(old)) {
          this.blinkFlag = false;
          this.$nextTick(() => {
            this.blinkFlag = true;
          });
        }
      },
      deep: true
    }
  },
  computed: {
    className() {
      if (!this.configList.length) return "";
      return "menu-style_" + this.configList[0].tag_menu_style;
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.menu-list {
  .van-tab--active {
    color: #ee0a24;

    &:before {
      position: absolute;
      bottom: 0;
      right: 0;
      top: 0;
      left: 0;
      background-color: #ee0a24;
    }
  }

  &.menu-style_1 {
    .van-tab--active {
      position: relative;
      color: #fff;

      &:before {
        content: "";
        bottom: 5px;
        right: 10px;
        top: 5px;
        left: 10px;
        border-radius: 17px;
      }
    }

    .van-tabs__line {
      opacity: 0;
    }
  }

  &.menu-style_2 {
    .van-tabs__wrap {
      overflow: visible;
    }

    .van-tabs__nav--line {
      padding-bottom: 0;
    }

    .van-tab__text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }

    .van-tab--active {
      color: #fff;
      overflow: visible;

      &:before {
        content: "";
      }

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        border: 5px solid transparent;
        border-top-color: #ee0a24;
      }
    }

    .van-tabs__line {
      opacity: 0;
    }
  }
}
</style>
